import CustomNavbar from 'components/core/CustomNavbar';
import Footer from 'components/core/Footer';
import { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { FaRegUser } from 'react-icons/fa';
import { IoMdCheckmark } from 'react-icons/io';
import { toast } from 'react-toastify';
import history from 'services/history';
import styles from 'styles/styles.module.css';
import validarCPF from 'validar-cpf';

// TODO: Implementar o cadastro de paciente com validação correta (zod)!!!
// confirmar quais campos são obrigatórios e quais não são pra criação de novo paciente!
export default function SignUpPac() {
  const [validated, setValidated] = useState(false);
  const [cpf, setCpf] = useState('');
  const [celular, setCelular] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmSenha, setConfirmSenha] = useState('');
  // TODO: form deve ser validado com Zod e não manualmente
  const isFormValid = Boolean(
    cpf &&
      validarCPF(cpf) &&
      celular &&
      senha.length >= 4 &&
      confirmSenha.length >= 4 &&
      senha === confirmSenha
  );

  async function signUp(payload) {
    toast.info('implementar isso em outro endpoint a ser criado: /paciente/criar');
    // const { cpf, celularPac, senha, confirmPassword } = payload;

    // if (!validarCPF(cpf)) {
    //   toast.warning('CPF inválido.');
    //   return;
    // }

    // if (senha !== confirmPassword) {
    //   toast.warning('Senhas não conferem.');
    //   return;
    // }

    // try {
    //   const response = await api.put('updatepac', {
    //     cpf,
    //     celularPac,
    //     senha,
    //     confirmPassword,
    //   });
    //   toast.success(response.data.message);
    //   history.push('/paciente/login');
    // } catch (error) {
    //   toast.error('Falha na atualização, verifique seus dados.');
    // }
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // TODO: usar local state e nao manipular o DOM diretamente!!!
      const cpf = event.target.elements.formBasicCPF.value;
      const celPac = event.target.elements.formBasicCelular.value;
      const senha = event.target.elements.formBasicSenha.value;
      const confirmPassword = event.target.elements.formBasicConfirmSenha.value;
      signUp({ cpf, celularPac: celPac, senha, confirmPassword });
    }

    setValidated(true);
  };

  return (
    <div
      className={`${styles.homePageFonts} d-flex flex-column min-vh-100`}
      style={{
        background: 'linear-gradient(180deg, #f7fbff 0%, #f5f7fb 100%)',
      }}
    >
      <CustomNavbar />

      <main className="flex-grow-1 pt-4 pt-lg-5 pb-4">
        <Container className="px-3 px-lg-4 pt-2">
          <Row className="align-items-start">
            <Col lg={6} className="d-none d-lg-flex align-self-start">
              <div className="pe-lg-5">
                <p
                  className="text-uppercase mb-3"
                  style={{ fontSize: '0.75rem', letterSpacing: '0.24em', color: '#d30a0a' }}
                >
                  Área do Paciente
                </p>
                <h1 className="display-6 fw-normal mb-3">
                  Crie seu acesso.
                  <br />
                  <span className="d-block fs-3 text-muted mt-2">
                    Tenha mais controle sobre sua saúde.
                  </span>
                </h1>

                <div className={styles.pulseWrap}>
                  <svg viewBox="0 0 620 56" preserveAspectRatio="none">
                    <line className={styles.pulseBaseline} x1="0" y1="28" x2="620" y2="28" />
                    <path
                      className={styles.pulseLine}
                      d="M0,28 L120,28 L145,28 L160,8 L178,48 L196,14 L214,28 L245,28 L470,28 L488,8 L506,48 L524,14 L542,28 L620,28"
                    />
                  </svg>
                </div>

                <p
                  className="text-muted mt-4 fw-light"
                  style={{
                    fontSize: '0.85rem',
                    maxWidth: '460px',
                    lineHeight: 1.7,
                  }}
                >
                  Cadastre-se para acessar suas informações de forma rápida e segura.
                </p>

                <Card
                  className="border-0 rounded-4 shadow-sm mt-4"
                  style={{
                    maxWidth: '260px',
                    background: 'rgba(255, 255, 255, 0.92)',
                  }}
                >
                  <Card.Body className="p-3 p-lg-4">
                    <div
                      className="text-uppercase mb-3 fw-semibold"
                      style={{
                        fontSize: '0.72rem',
                        letterSpacing: '0.18em',
                        color: '#1d5c8a',
                      }}
                    >
                      Benefícios
                    </div>

                    <div className="d-grid gap-2">
                      <div className="d-flex align-items-center gap-2 text-muted small fw-medium">
                        <span
                          className="d-inline-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: 20,
                            height: 20,
                            background: '#e7f8f2',
                            color: '#1e8f71',
                            fontWeight: 700,
                          }}
                        >
                          <IoMdCheckmark />
                        </span>
                        Resultados de exames
                      </div>

                      <div className="d-flex align-items-center gap-2 text-muted small fw-medium">
                        <span
                          className="d-inline-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: 20,
                            height: 20,
                            background: '#e7f8f2',
                            color: '#1e8f71',
                            fontWeight: 700,
                          }}
                        >
                          <IoMdCheckmark />
                        </span>
                        Consultas e agendamentos
                      </div>

                      <div className="d-flex align-items-center gap-2 text-muted small fw-medium">
                        <span
                          className="d-inline-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: 20,
                            height: 20,
                            background: '#e7f8f2',
                            color: '#1e8f71',
                            fontWeight: 700,
                          }}
                        >
                          <IoMdCheckmark />
                        </span>
                        Documentos clínicos
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>

            <Col lg={6} className="d-flex justify-content-center align-items-start">
              <Card
                className="border-0 shadow rounded-4 position-relative"
                style={{
                  maxWidth: 520,
                  width: '100%',
                  marginTop: 0,
                  background: 'rgba(255, 255, 255, 0.96)',
                  border: '1px solid rgba(30, 143, 113, 0.12)',
                }}
              >
                <Card.Body className="p-4 p-lg-23">
                  <div className="d-flex justify-content-center mb-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: 70,
                        height: 70,
                        background: '#e7f8f2',
                        color: '#1e8f71',
                      }}
                    >
                      <FaRegUser size={32} />
                    </div>
                  </div>

                  <h4 className="text-center mb-2" style={{ color: '#10242a' }}>
                    Cadastro de Paciente
                  </h4>
                  <p
                    className="text-center mb-4"
                    style={{
                      color: '#5a6b76',
                      fontSize: '0.85rem',
                      lineHeight: 1.6,
                    }}
                  >
                    Complete o cadastro para obter acesso ao portal do paciente.
                  </p>

                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group controlId="formBasicCPF" className="mb-3">
                      <Form.Label className="fw-semibold" style={{ color: '#10242a' }}>
                        CPF do Paciente
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="000.000.000-00"
                        value={cpf}
                        onChange={(event) => setCpf(event.target.value)}
                        style={{
                          borderRadius: 14,
                          borderColor: '#d7e4ec',
                          padding: '0.8rem 1rem',
                          background: '#f9fbfc',
                        }}
                      />
                      <Form.Control.Feedback type="invalid">Digite seu CPF.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formBasicCelular" className="mb-3">
                      <Form.Label className="fw-semibold" style={{ color: '#10242a' }}>
                        Celular
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="(DDD) 99999-9999"
                        value={celular}
                        onChange={(event) => setCelular(event.target.value)}
                        style={{
                          borderRadius: 14,
                          borderColor: '#d7e4ec',
                          padding: '0.8rem 1rem',
                          background: '#f9fbfc',
                        }}
                      />
                      <Form.Text className="text-muted" style={{ fontSize: '0.75rem' }}>
                        Informe o número com DDD entre parênteses.
                      </Form.Text>
                      <Form.Control.Feedback type="invalid">
                        Digite seu Celular.
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formBasicSenha" className="mb-3">
                      <Form.Label className="fw-semibold" style={{ color: '#10242a' }}>
                        Senha
                      </Form.Label>
                      <Form.Control
                        required
                        minLength="4"
                        type="password"
                        placeholder="Digite sua senha"
                        value={senha}
                        onChange={(event) => setSenha(event.target.value)}
                        style={{
                          borderRadius: 14,
                          borderColor: '#d7e4ec',
                          padding: '0.8rem 1rem',
                          background: '#f9fbfc',
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Mínimo de quatro (4) dígitos.
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formBasicConfirmSenha" className="mb-3">
                      <Form.Label className="fw-semibold" style={{ color: '#10242a' }}>
                        Confirme sua senha
                      </Form.Label>
                      <Form.Control
                        required
                        minLength="4"
                        type="password"
                        placeholder="Confirme sua senha"
                        value={confirmSenha}
                        onChange={(event) => setConfirmSenha(event.target.value)}
                        style={{
                          borderRadius: 14,
                          borderColor: '#d7e4ec',
                          padding: '0.8rem 1rem',
                          background: '#f9fbfc',
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Mínimo de quatro (4) dígitos.
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="success"
                      disabled={!isFormValid}
                      className={`rounded-pill w-100 mb-3 border-0 ${styles.cardBtn} ${styles.cardBtnGreen}`}
                      style={{
                        minHeight: '3rem',
                        padding: '0.85rem 1rem',
                        fontWeight: 700,
                        color: '#ffffff',
                      }}
                    >
                      Cadastrar
                    </Button>

                    <Button
                      type="button"
                      className={`rounded-pill w-100 border-0 ${styles.cardBtn}`}
                      style={{
                        background: '#e7f8f2',
                        color: '#1e8f71',
                        padding: '0.85rem 1rem',
                        fontWeight: 700,
                      }}
                      onClick={() => history.push('/paciente/login')}
                    >
                      Já possui acesso?
                    </Button>

                    <p
                      className="text-center mt-3 mb-0 fw-light text-secondary"
                      style={{
                        fontSize: '0.75rem',
                        lineHeight: 1.5,
                      }}
                    >
                      <span className="fw-normal">Problemas no acesso? </span>
                      Fale com nosso{' '}
                      <a
                        href="https://wa.link/7ulmr2"
                        target="_blank"
                        rel="noreferrer"
                        className="text-secondary"
                        style={{
                          textDecoration: 'underline',
                        }}
                      >
                        suporte
                      </a>
                      .
                    </p>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>

      <Footer />
    </div>
  );
}
